import React from 'react';
import PropTypes from 'prop-types';
import { InlineWrapper, OptionButton } from './InlineComfirmation.styled';
import useDebouncedCallback from 'hooks/useDebouncedCallback';

const InlineConfirmation = ({
  label,
  confirmOption,
  cancelOption,
  onConfirm,
  onCancel
}) => {
  const debounceOnConfirm = useDebouncedCallback(onConfirm);
  const debounceOnCancel = useDebouncedCallback(onCancel);

  return (
    <InlineWrapper>
      {label}
      <OptionButton
        type="button"
        onClick={debounceOnConfirm}
        data-testid="inline-confirmation-yes"
      >
        {confirmOption}
      </OptionButton>
      <OptionButton
        type="button"
        onClick={debounceOnCancel}
        data-testid="inline-confirmation-no"
      >
        {cancelOption}
      </OptionButton>
    </InlineWrapper>
  );
};

InlineConfirmation.propTypes = {
  label: PropTypes.string,
  confirmOption: PropTypes.string,
  cancelOption: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

InlineConfirmation.defaultProps = {
  label: 'Are you sure?',
  confirmOption: 'Yes',
  cancelOption: 'No'
};

export default InlineConfirmation;
